import { OptionType } from 'components';

export enum ContactReason {
    INFO_GARANTIES_DECOMPTES = 'contact.reason.infoGarantiesDecomptes',
    INFO_ADHESION = 'contact.reason.infoAdhesion',
    INFO_COMMERCIAL = 'contact.reason.infoCommercial',
    INFO_COTISATION = 'contact.reason.infoCotisation',
    RECLAMATION = 'contact.reason.reclamation',
    SUPPORT_TECHNIQUE = 'Support technique',
}

export type ContactPhone =
    | {
          personnel: string;
      }
    | {
          bureau: string;
      }
    | {
          mobile: string;
      };

export type ContactEmail = {
    email: string;
};

export type ContactPostal = {
    adresse: string;
};

export type ContactForm = {
    idContrat: string;
    raison: ContactReason;
    commentaire: string;
    recevoirUneCopie: boolean;
    contact: ContactPhone | ContactEmail | ContactPostal;
    user?: any;
    firstname: string;
    lastname: string;
    company: string;
    emailCopy?: string;
};

export type SouscripteurCod = string;
export type ContratCod = string;
export type ContactContratData = {
    contrat: string;
};
export type ContactSouscripteurData = Record<SouscripteurCod, Record<ContratCod, ContactContratData>>;

export type ContractExtended = {
    map(arg0: (id: any) => { value: any; label: string }): any;
    cod: string;
    lbContrat: string;
    souscripteurCod: string;
    lbSouscripteur: string;
    lbRespadhes: string;
    lbRespadhesEmail: string;
    lbResppresta: string;
    lbRespprestaEmail: string;
    type: string;
    codTypeContrat: number;
    typeContrat: string;
};

export type ContractType = 1 | 2 | 3 | 4 | 5 | 6 | 7;

export const contractTypes: Record<ContractType, string> = {
    1: 'Socle',
    2: 'Socle obligatoire',
    3: 'ANI',
    4: 'Surco obligatoire',
    5: 'Surco facultative',
    6: 'ANI surco obligatoire',
    7: 'ANI surco facultative',
};

export const getContractTypeLabel = (type: ContractType) => {
    let label = contractTypes[type] || '';

    if ([3, 6, 7].includes(type)) {
        label = '--- ANI';
    } else if ([4, 5].includes(type)) {
        label = '--- SURCO';
    } else {
        label = '';
    }

    return label;
};

export type ContractOptionType<T = string> = OptionType<T> & {
    lbRespadhes: string;
    lbResppresta: string;
};
